// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AirportPickerController from "./airport_picker_controller"
application.register("airport-picker", AirportPickerController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)
